import { ICalls, CallStatus, Sentiment, ICall } from 'interfaces/Reporting';
import dayjs from 'dayjs';

export const generateMockCallsForFreeAccounts = (
  start: number,
  count: number
) => {
  return Array.from({ length: count }, (_, i) => ({
    id: `${start + i + 1}`,
    participant: {
      phone_number: '+1 (555) 123-4567',
    },
    start_time: dayjs()
      .subtract(Math.floor(Math.random() * 7), 'days')
      .format('YYYY-MM-DD HH:mm:ss'),
    duration: Math.floor(Math.random() * 10) + 1,
    resolution: Object.values(CallStatus)[
      Math.floor(Math.random() * 5)
    ] as ICall['resolution'],
    sentiment: {
      [Sentiment.POSITIVE]: Math.random() * 0.3 + 0.7,
      [Sentiment.NEGATIVE]: Math.random() * 0.3 + 0.7,
      [Sentiment.NEUTRAL]: Math.random() * 0.3 + 0.7,
    },
  }));
};

export const generateMockCallsByDateRange = (
  startDate?: Date,
  endDate?: Date,
  page: number = 1,
  size: number = 10
): ICalls => {
  const end = endDate;
  const start = startDate;
  const allItems = [];

  // Generate all data first
  let currentDate = dayjs(start);
  const endDay = dayjs(end);

  while (currentDate.isBefore(endDay) || currentDate.isSame(endDay, 'day')) {
    // Generate 1-6 calls per day
    const callsPerDay = Math.floor(Math.random() * 15) + 5;

    for (let j = 0; j < callsPerDay; j++) {
      const hour = Math.floor(Math.random() * 24);
      const minute = Math.floor(Math.random() * 60);

      allItems.push({
        id: `mock-${currentDate.format('YYYY-MM-DD')}-${j}`,
        start_time: currentDate.hour(hour).minute(minute).toISOString(),
        duration: Math.floor(Math.random() * 600) + 60, // 1-10 minutes
        resolution: Object.values(CallStatus)[Math.floor(Math.random() * 4)],
        sentiment: {
          neg: Math.random() * 0.3,
          neu: Math.random() * 0.4,
          pos: Math.random() * 0.3,
          compound: Math.random() * 2 - 1,
        },
        participant: {
          phone_number: `+1${Math.floor(Math.random() * 9000000000) + 1000000000}`,
          type: 'caller',
          direction: 'inbound',
          call_sid: `mock-sid-${currentDate.format('YYYY-MM-DD')}-${j}`,
        },
      });
    }

    currentDate = currentDate.add(1, 'day');
  }

  // Sort items by start_time in descending order (newest first)
  allItems.sort((a, b) => dayjs(b.start_time).diff(dayjs(a.start_time)));

  // Calculate pagination
  const total = allItems.length;
  const pages = Math.ceil(total / size);
  const startIndex = (page - 1) * size;
  const endIndex = Math.min(startIndex + size, total);

  // Return paginated result
  return {
    items: allItems.slice(0, endIndex),
    total,
    page,
    size,
    pages,
  };
};
